import { ReportType } from '@grcs/types/DataTypes';

export const punctuationRegex =
  /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ！？。，、；：“”‘’【】「」『』《》（）—…￥]+/;
export const alphabetRegex = /[a-zA-Z0-9]+/;

export const calculateHanziUsage = (
  input: string,
  requiredHanzi: string,
  hanziList: Record<string, Record<string, string[]>>,
): ReportType => {
  const frequencyByRequireTmp: Record<string, number> = {};
  const frequencyByGrade: Record<string, number> = {};
  const newHanziList: Record<string, number> = {};
  let newHanziCount = 0;
  const knownHanziSet = new Set<string>();
  const requiredHanziSet = new Set<string>();

  const hanzis = input
    .split(punctuationRegex)
    .join('')
    .split(alphabetRegex)
    .join('')
    .split('\n')
    .join('');
  const required_hanzis = requiredHanzi
    .split(punctuationRegex)
    .join('')
    .split(alphabetRegex)
    .join('')
    .split('\n')
    .join('');

  const grades = Object.keys(hanziList);
  // initialize requrired list
  for (const hanzi of required_hanzis) {
    frequencyByRequireTmp[hanzi] = 0;
  }
  for (const hanzi of hanzis) {
    if (required_hanzis.includes(hanzi)) {
      frequencyByRequireTmp[hanzi] = (frequencyByRequireTmp[hanzi] || 0) + 1;
      requiredHanziSet.add(hanzi);
    } else {
      let found_in_hanziList = false;
      for (const grade of grades) {
        const hanzi_list = Object.keys(hanziList[grade]);
        if (hanzi_list.includes(hanzi)) {
          frequencyByGrade[grade] = (frequencyByGrade[grade] || 0) + 1;
          knownHanziSet.add(hanzi);
          found_in_hanziList = true;
          break;
        }
      }
      // not in the hanzi list, must be a new (sheng pi) hanzi
      if (!found_in_hanziList) {
        newHanziList[hanzi] = (frequencyByGrade[hanzi] || 0) + 1;
        newHanziCount = newHanziCount + 1;
      }
    }
  }
  // sort required hanzi
  const entries: [string, number][] = Object.entries(frequencyByRequireTmp);
  // Sort the array based on the number values in ascending order
  entries.sort((a, b) => a[1] - b[1]);

  // calculate hanzi usage
  const report: ReportType = {
    known_hanzi: Array.from(knownHanziSet).join(','),
    known_hanzi_by_grade: frequencyByGrade,
    unknown_hanzi: Array.from(Object.keys(newHanziList)).join(','),
    unknown_hanzi_overall:
      ((newHanziCount / hanzis.length) * 100).toFixed(0) + '%',
    unknown_hanzi_usage:
      (
        (Object.keys(newHanziList).length /
          (knownHanziSet.size +
            requiredHanziSet.size +
            Object.keys(newHanziList).length)) *
        100
      ).toFixed(0) + '%',
    required_hanzi_frequency: Object.fromEntries(entries),
  };
  return report;
};
